import { TechnicalObjectOracle } from 'src/models/technical-object';
import { GPSPoint } from '@models';

export const getTosWithingRange = async (
  coordinates: GPSPoint,
  radius = 300
  // voltageLevel = 'NN' //TODO:, right now it is hardcoded to NN, check the parent
) => {
  const response = await fetch(
    `/api/zsd/technical-object/list/within-radius?longitude=${coordinates.longitude}&latitude=${coordinates.latitude}&radius=${radius}`
  );

  return (await response.json()) as TechnicalObjectOracle[];
};
